import React from 'react';
import { Grid, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import QueryIcon from '../../atoms/Icons/QueryIcon';
import ClearFilter from '../../atoms/Icons/ClearFilter';
import { DottedText } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { useStores } from '../../../stores';
import { toJS } from 'mobx';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

interface CohortFilterBarProps {
  conditionsDetails?: string[];
}

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  queryIconGrid: {
    padding: '10px 0px 10px 22px',
  },
  queryDataOverallGrid: {
    margin: '10px 10px 10px 0px',
    height: '44px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DADEEF',
    borderRadius: '4px',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataTypography: {
    padding: '10px 10px',
    height: '44px',
    borderRight: '1px solid #DADEEF',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataGrid: {
    maxWidth: '400px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '60px',
  },
  tooltip: {
    backgroundColor: '#1A1A1A',
    padding: '10px',
    fontSize: '13px',
    fontFamily: 'Inter',
    fontWeight: 400,
    lineHeight: '16px',
    color: '#FFFFFF',
  },
  arrow: {
    color: '#1A1A1A',
    marginLeft: '50px',
  },
  clearFilterGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingRight: '12px',
    cursor: 'pointer',
    gap: 4,
    backgroundColor: '#E5E9F0',
    padding: 10,
  },
});

const CohortFilterBar: React.FC<CohortFilterBarProps> = () => {
  const { classes } = useStyles();
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const conditionsDetails = toJS(cohortDetailsStore.conditionsDetails);

  if (!conditionsDetails || conditionsDetails.length === 0) {
    return null;
  }

  const handleClearFilter = () => {
    cohortDetailsStore.setCohortDetailsList([
      {
        id: 1,
        category: '',
        condition: '',
        property: '',
        results: '',
        dropdownSelectionTypeIndex: 0,
        andOrCondition: 'AND',
        propertiesPageNumber: 0,
        totalPagesForProperties: 0,
      },
    ]);

    cohortDetailsStore.removeConditionsDetails();
    cohortDetailsStore.removeClaimIdList();
    cohortDetailsStore.removeMemberUniqueIdList();
    cohortDetailsStore.setToggleList([]);
  };

  return (
    <Grid container className={classes.root}>
      <Grid container direction="row" className={classes.queryDataOverallGrid}>
        {/* Query Icon */}
        <Grid className={classes.queryIconGrid}>
          <QueryIcon />
        </Grid>

        {/* Conditions */}
        {conditionsDetails.map((detail, index: number) => (
          <Tooltip
            key={index}
            arrow
            placement="bottom-end"
            classes={{
              tooltip: classes.tooltip,
              arrow: classes.arrow,
            }}
            title={
              <Typography fontSize="14px">
                {conditionsDetails.join(' ')}
              </Typography>
            }
          >
            <Grid className={classes.queryDataGrid}>
              <Typography
                fontType="medium"
                className={classes.queryDataTypography}
              >
                {detail}
              </Typography>
            </Grid>
          </Tooltip>
        ))}

        {/* Clear Filter */}
        <Grid className={classes.clearFilterGrid} onClick={handleClearFilter}>
          <ClearFilter />

          <DottedText
            typographyStyles={{
              color: '#6C7DC0',
              fontSize: 14,
              fontWeight: 600,
            }}
            text="Clear Filter"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CohortFilterBar;
